import React from 'react';
import {
  Box,
  Typography,
  TextField,
} from '@mui/material';
import type { SiteEditState } from '../../../../types/visualEditor';

export interface SEOTagsTabProps {
  editState: SiteEditState;
  updateEditState: (updates: Partial<SiteEditState>) => void;
}

export const SEOTagsTab: React.FC<SEOTagsTabProps> = ({ editState, updateEditState }) => (
  <Box sx={{ p: 2, width: '800px' }}>
    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, mb: 1, fontSize: '18px' }}>
      Webサイト全体のSEO設定：
    </Typography>
    
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px' }}>Titleタグ</Typography>
        <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>60文字以内推奨</Typography>
      </Box>
      <TextField
        fullWidth
        placeholder="例) △△なら株式会社○○| 導入・運用まで一貫サポート"
        variant="outlined"
        value={editState.metaTitle ?? ''}
        onChange={(e) => updateEditState({ metaTitle: e.target.value })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px' }}>H1タグ</Typography>
        <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>70文字以内推奨</Typography>
      </Box>
      <TextField
        fullWidth
        placeholder="例) △△で、ビジネスの成長を支援する株式会社○○"
        variant="outlined"
        value={editState.settings?.metaH1 ?? ''}
        onChange={(e) => updateEditState({
          settings: { ...editState.settings, metaH1: e.target.value },
        })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>

    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px' }}>Descriptionタグ</Typography>
        <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>160文字以内推奨</Typography>
      </Box>
      <TextField
        fullWidth
        multiline
        rows={3}
        placeholder="例)株式会社○○は、△△を通じて企業の課題解決を支援しています。導入から運用まで一貫してサポートし、ビジネスの成長を実現します。"
        variant="outlined"
        value={editState.metaDescription ?? ''}
        onChange={(e) => updateEditState({ metaDescription: e.target.value })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>

    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, mb: 1, fontSize: '18px' }}>
      各種タグ設定
    </Typography>
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px' }}>&lt;head&gt;〜&lt;/head&gt;内</Typography>
        <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>65355文字以内推奨</Typography>
      </Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder="<meta name='---' content='---'>"
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
    
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontSize: '16px' }}>&lt;body&gt;〜&lt;/body&gt;内</Typography>
        <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>65355文字以内推奨</Typography>
      </Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder="<script src='---'></script>"
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
  </Box>
);
